import { render } from "./ImportOnboarding.vue?vue&type=template&id=d02d0aac&scoped=true"
import script from "./ImportOnboarding.vue?vue&type=script&lang=js"
export * from "./ImportOnboarding.vue?vue&type=script&lang=js"

import "./ImportOnboarding.vue?vue&type=style&index=0&id=d02d0aac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d02d0aac"]])

export default __exports__